import Menu from '@/global/components/MenuV2'
import Grid from '@/global/components/ui/Grid'
import { Divider } from '@mui/material'
import { FormField, FormFieldCheckbox } from 'global/components/Form'
import IconeAjuda from 'global/components/IconeAjuda'
import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

export function FormAdicionalNoturno() {
    const { watch, setValue } = useFormContext()

    const [temAdicionalNoturno, inicio, fim] = watch([
        'temAdicionalNoturno',
        'horarioInicioAdicionalNoturno',
        'horarioFimAdicionalNoturno',
    ])

    useEffect(() => {
        if (inicio == '22:00' && fim == '05:00') {
            setValue('tmp_ramo', 1)
        } else if (inicio == '21:00' && fim == '05:00') {
            setValue('tmp_ramo', 2)
        } else if (inicio == '20:00' && fim == '04:00') {
            setValue('tmp_ramo', 3)
        } else {
            setValue('tmp_ramo', -1)
        }
    }, [inicio, fim])

    return (
        <section id="adicional-noturno">
            <Divider className="select-none mt-6 mb-5">
                <span className="inline-flex items-center">
                    Adicional noturno&nbsp;
                    <IconeAjuda>
                        O adicional noturno é um benefício que a CLT concede aos
                        profissionais que executam suas funções à noite como uma
                        forma de recompensá-los pelo desgaste físico e mental
                        que sofrem. Na legislação trabalhista, o horário noturno
                        é dividido da seguinte maneira:
                        <br />
                        <br />
                        <table className="border-collapse border rounded-sm [&_th]:border [&_td]:border">
                            <thead>
                                <tr className="*:px-2">
                                    <th>Ramo</th>
                                    <th>Horário noturno</th>
                                    <th>Redução</th>
                                </tr>
                            </thead>
                            <tbody className="[&_tr>td]:px-3">
                                <tr>
                                    <td>Urbano</td>
                                    <td>22h às 5h</td>
                                    <td>1h = 52min30s</td>
                                </tr>
                                <tr>
                                    <td>Rural</td>
                                    <td>21h às 5h</td>
                                    <td>Não se aplica</td>
                                </tr>
                                <tr>
                                    <td>Pecuária</td>
                                    <td>20h às 4h</td>
                                    <td>Não se aplica</td>
                                </tr>
                            </tbody>
                        </table>
                    </IconeAjuda>
                </span>
            </Divider>
            <Grid container spacing={2}>
                <Grid item xs={5} className="flex flex-row items-center mt-2">
                    <FormFieldCheckbox
                        name="temAdicionalNoturno"
                        label="Tem adicional noturno"
                    />
                    <IconeAjuda>
                        Se esta opção estiver habilitada, o adicional noturno
                        será calculado seguindo o horário noturno informado,
                        caso contrário, o adicional noturno não será calculado
                        nem exibido no espelho de ponto.
                    </IconeAjuda>
                </Grid>
                <Grid item xs={7}>
                    <FormField
                        name="tmp_ramo"
                        label="Ramo do adicional noturno"
                        select
                        disabled={!temAdicionalNoturno}
                        SelectProps={{
                            MenuProps: {
                                PaperProps: {
                                    sx: {
                                        width: 192,
                                        marginLeft: 0,
                                    },
                                },
                            },
                        }}
                    >
                        <Menu.Item value={-1}>Outro ramo</Menu.Item>
                        <Menu.Item
                            value={1}
                            onClick={() => {
                                setValue(
                                    'horarioInicioAdicionalNoturno',
                                    '22:00',
                                )
                                setValue('horarioFimAdicionalNoturno', '05:00')
                            }}
                        >
                            Urbano
                        </Menu.Item>
                        <Menu.Item
                            value={2}
                            onClick={() => {
                                setValue(
                                    'horarioInicioAdicionalNoturno',
                                    '21:00',
                                )
                                setValue('horarioFimAdicionalNoturno', '05:00')
                            }}
                        >
                            Agrícola
                        </Menu.Item>
                        <Menu.Item
                            value={3}
                            onClick={() => {
                                setValue(
                                    'horarioInicioAdicionalNoturno',
                                    '20:00',
                                )
                                setValue('horarioFimAdicionalNoturno', '04:00')
                            }}
                        >
                            Pecuária
                        </Menu.Item>
                    </FormField>
                </Grid>
                <Grid item xs={12 / 3}>
                    <FormField
                        name="horarioInicioAdicionalNoturno"
                        type="time"
                        label="Início do adicional noturno"
                        required
                        disabled={!temAdicionalNoturno}
                        InputProps={{
                            endAdornment: (
                                <IconeAjuda>
                                    O horário de início do adicional noturno
                                    deve ser preenchido com o horário que varia
                                    de acordo com o ramo da empresa. Por
                                    exemplo, no ramo urbano, o horário de início
                                    é às 22h.
                                    <br />
                                    Registros marcados após esse horário dão
                                    início ao adicional noturno.
                                </IconeAjuda>
                            ),
                        }}
                    />
                </Grid>
                <Grid item xs={12 / 3}>
                    <FormField
                        name="horarioFimAdicionalNoturno"
                        type="time"
                        label="Fim do adicional noturno"
                        required
                        disabled={!temAdicionalNoturno}
                        InputProps={{
                            endAdornment: (
                                <IconeAjuda>
                                    O horário de fim do adicional noturno deve
                                    ser preenchido com o horário que varia de
                                    acordo com o ramo da empresa. Por exemplo,
                                    no ramo urbano, o horário de fim é às 5h.
                                    <br />
                                    Registros marcados antes desse horário dão
                                    início ao adicional noturno.
                                </IconeAjuda>
                            ),
                        }}
                    />
                </Grid>
                <Grid item xs={12 / 3}>
                    <FormField
                        name="horarioEncerramentoAdicionalNoturno"
                        type="time"
                        label="Fim da extensão"
                        disabled={!temAdicionalNoturno}
                        InputProps={{
                            endAdornment: (
                                <IconeAjuda>
                                    Caso o empregado tenha o início de sua
                                    jornada de trabalho no horário diurno, ou
                                    seja, antes do{' '}
                                    <strong>Início do adicional noturno</strong>
                                    , e sua jornada seja estendida após o{' '}
                                    <strong>Fim do adicional noturno</strong>,
                                    terá direito ao adicional noturno até o fim
                                    da sua jornada de trabalho.
                                    <br />
                                    Deixe este campo em branco para que a
                                    extensão do adicional noturno seja até o fim
                                    da jornada.
                                    <br />
                                    Preencha este campo para determinar um
                                    horário fixo para o fim da extensão do
                                    adicional noturno, mesmo que a jornada
                                    ultrapasse esse horário.
                                </IconeAjuda>
                            ),
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <div className="flex items-center w-full select-none">
                        <FormFieldCheckbox
                            name="reducaoHrsATrabalhar"
                            label="Redução de horas a trabalhar"
                            defaultChecked={true}
                        />
                        <IconeAjuda>
                            A redução de horas a trabalhar é uma opção que
                            permite que o trabalhador tenha uma jornada reduzida
                            durante o período noturno, se esta opção estiver
                            habilitada, a cada 52 minutos e 30 segundos será
                            contabilizado como 1 hora trabalhada, ou seja, se o
                            funcionário trabalhar 7 horas, serão contabilizadas
                            8 horas trabalhadas.
                        </IconeAjuda>
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <div className="flex items-center w-full select-none">
                        <FormFieldCheckbox
                            name="reducaoSomenteAdicionalNoturno"
                            label="Redução sobre adicional noturno"
                        />
                        <IconeAjuda>
                            Se esta opção estiver habilitada, a redução de horas
                            será aplicada sobre o adicional noturno, ou seja, a
                            cada 52 minutos e 30 segundos trabalhados no período
                            noturno, será contabilizado 1 hora de adicional
                            noturno.
                        </IconeAjuda>
                    </div>
                </Grid>
            </Grid>
        </section>
    )
}
